var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define('charts/polar',["require", "exports", "../tracks/track-enabled", "../tracks/track-state", "../util/bounds", "../util/convert", "./basechart", "./charthelpers", "./layers/diagonals", "./layers/ellipses", "./layers/polarfocus", "./layers/polarlayer"], function (require, exports, trackEnabled, trackState, bounds_1, convert_1, basechart_1, charthelpers_1, diagonals_1, ellipses_1, polarfocus_1, polarlayer_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.init = exports.PolarChart = void 0;
    var margin = {
        bottom: 2,
        top: 15,
        right: 2,
        left: 50
    };
    var PolarChart = /** @class */ (function (_super) {
        __extends(PolarChart, _super);
        function PolarChart(options) {
            var _this = _super.call(this, "#drag-polar", margin, 1) || this;
            _this.speedLayers = {};
            _this.options = options;
            _this.focusLayer = new polarfocus_1.PolarFocus(options);
            // Setup axes
            _this.xAxis.gridLines = true;
            _this.xAxis.axis
                .ticks(5)
                .tickFormat(function (d) { return Math.floor(d) + convert_1.default.speed.label; });
            _this.yAxis[0].gridLines = true;
            _this.yAxis[0].axis
                .ticks(5)
                .tickFormat(function (d) { return Math.floor(d) + convert_1.default.speed.label; });
            // Add ChartLayers
            _this.addLayer(new diagonals_1.Diagonals(3));
            _this.addLayer(new ellipses_1.Ellipses());
            // Add darker horizon line
            _this.layers.axes.horizon = _this.layers.axes.append("line")
                .attr("class", "horizon")
                .style("stroke", "#222")
                .style("stroke-width", 1);
            // Add polar group layer
            _this.layers.polars = _this.layers.space.append("g")
                .attr("class", "polars");
            // Add ChartLayers
            _this.addLayer(_this.focusLayer);
            // Listen for mouse movements
            _this.layers.overlay
                .on("mouseout", function () { return _this.unfocus(); })
                .on("mousemove", function (evnt) { return _this.mousemove(evnt); });
            // On window resize, re-draw the chart
            window.addEventListener("resize", function () { return _this.update(); });
            // Listen for updates
            trackState.focusUpdates.subscribe(function (point) { return _this.focusLayer.drawFocus(point); });
            trackState.trimUpdates.subscribe(function () { return _this.update(); });
            trackEnabled.trackEnabled.subscribe(function (track) {
                if (track.trackType !== "laser") {
                    if (_this.speedLayers[track.track_id]) {
                        console.error("Layer added twice", _this.speedLayers[track.track_id], track);
                    }
                    _this.speedLayers[track.track_id] = new polarlayer_1.PolarLayer(track, options);
                    _this.addLayer(_this.speedLayers[track.track_id]);
                    _this.update();
                }
            });
            trackEnabled.trackDisabled.subscribe(function (track_id) {
                if (_this.speedLayers[track_id]) {
                    _this.removeLayer(_this.speedLayers[track_id]);
                    delete _this.speedLayers[track_id];
                    _this.update();
                }
            });
            // Initial chart update
            _this.update();
            return _this;
        }
        /**
         * Update chart data
         */
        PolarChart.prototype.update = function () {
            if (this.svg === undefined)
                return console.error("Should not update without chart");
            // Update bounds
            var width = this.width();
            var height = this.height();
            // Scale the range of the data
            var bounds = (0, charthelpers_1.getBounds)(trackEnabled.enabled, this.options);
            bounds = (0, bounds_1.cleanBounds)(bounds, this.options.inner(), this.options.outer());
            bounds = (0, bounds_1.squareBounds)(bounds, width, height);
            this.xAxis.scale.domain([bounds.x.min, bounds.x.max]);
            this.yAxis[0].scale.domain([bounds.y.min, bounds.y.max]);
            // Update horizon line
            var y0 = this.yAxis[0].scale(0);
            this.layers.axes.horizon
                .attr("x1", 0)
                .attr("y1", y0)
                .attr("x2", width)
                .attr("y2", y0);
            // Do the chart update AFTER we've updated the axes
            _super.prototype.update.call(this);
        };
        PolarChart.prototype.mousemove = function (evnt) {
            var _a;
            var x0 = this.xAxis.scale.invert(d3.pointer(evnt)[0]);
            var y0 = this.yAxis[0].scale.invert(d3.pointer(evnt)[1]);
            var closest = (0, charthelpers_1.closestPoint)(trackEnabled.enabled, this.options, x0, y0);
            // Notify other focus listeners
            if (closest) {
                // Check distance in screen space
                if ((0, charthelpers_1.checkDistance)(this, this.options, closest[0], evnt)) {
                    (_a = trackState.focusUpdates).post.apply(_a, closest);
                }
                else {
                    this.unfocus();
                }
            }
            else {
                this.unfocus();
            }
        };
        PolarChart.prototype.unfocus = function () {
            trackState.focusUpdates.post(undefined);
        };
        return PolarChart;
    }(basechart_1.BaseChart));
    exports.PolarChart = PolarChart;
    function init() {
        if (!document.getElementById("drag-polar"))
            return;
        new PolarChart({
            fx: function (d) { return d && convert_1.default.speed.localValue(d.groundspeed); },
            fy: function (d) { return d && convert_1.default.speed.localValue(d.climb); },
            inner: function () { return ({
                x: { min: 0, max: 10 },
                y: { min: -10, max: 0 }
            }); },
            outer: function () { return ({
                x: { min: 0, max: 100 * convert_1.default.speed.units /* max 220mph horizontal */ },
                y: { min: -111 * convert_1.default.speed.units /* max 250mph down */, max: 50 * convert_1.default.speed.units /* max 90mph up */ }
            }); }
        });
    }
    exports.init = init;
});
//# sourceMappingURL=/assets/javascripts/charts/polar.js.map;
